import React from "react";
import "./services.css";

const ServiceZones = ({ title, zones = [] }) => {
  return (
    <section className="svc-zones-section">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up" data-aos-duration="800" data-aos-once="true">
          <h2 className="h2-title light-title">{title}</h2>
        </div>

        <div className="row g-4">
          {zones.map((zone, i) => (
            <div
              key={i}
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="700"
              data-aos-delay={`${(i % 3) * 100}`}
              data-aos-once="true"
            >
              <div className="svc-zone-card">
                <div className="svc-zone-icon">
                  <i className={`bi ${zone.icon}`}></i>
                </div>
                <div className="svc-zone-name">{zone.name}</div>
                <p className="svc-zone-desc">{zone.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceZones;
